// Hub metadata for the URLs listed in the Google Search Console export dated 2026-08-10.
// Child URLs are never rewritten here; the hubs only expose crawlable internal links.

export const searchConsoleHubPages = [
  {
    path: "/ai",
    basePath: "/ai",
    locale: "en",
    lang: "en",
    localeName: "English",
    title: "AI Guides, Tools and Model Comparisons TechniaHQRobot",
    heading: "AI guides, tools and model comparisons",
    eyebrow: "AI article library",
    description: "Browse 27 AI guides covering ChatGPT, Claude, Gemini, Grok, DeepSeek, coding tools, image and video generators, comparisons and practical workflows.",
    intro: "This index connects every AI guide published in this section. Open a model guide, compare tools or move directly to a practical workflow without relying on search.",
    directoryHeading: "All AI guides in this section",
  },
  {
    path: "/articles",
    basePath: "/articles",
    locale: "en",
    lang: "en",
    localeName: "English",
    title: "Robotics Articles, Companies and Systems TechniaHQRobot",
    heading: "Robotics articles and technical systems",
    eyebrow: "Robotics article library",
    description: "Browse robotics articles covering AMRs, warehouse picking, robot fleets, industrial suppliers, sensing, simulation, training data and control systems.",
    intro: "Explore reporting on mobile robots, warehouse automation, sensing and control. Each article includes the technical context and supporting references.",
    directoryHeading: "All robotics articles in this section",
  },
  {
    path: "/guides",
    basePath: "/guides",
    locale: "en",
    lang: "en",
    localeName: "English",
    title: "Robotics and Physical AI Guides | TechniaHQRobot",
    heading: "Find the right robotics guide",
    eyebrow: "Robotics learning library",
    description: "Start with robot hardware, sensors, software, Physical AI or training. Choose a guide based on the task you want to understand or the system you plan to build.",
    intro: "A robot project brings together mechanics, sensing and control. Start with the part you need to understand, then follow the supporting guides. For a buying decision, compare the complete task, operating conditions and maintenance needs alongside the published specifications.",
    directoryHeading: "Starting points for robotics and Physical AI",
    dateModified: "2026-09-15",
    curatedLinks: [
      { path: "/humanoid-robots", label: "Understand humanoid robots", description: "Study the relationship between body design, locomotion, hands and task control. This is a useful starting point before comparing individual robot models or interpreting a demonstration." },
      { path: "/robot-sensors", label: "Choose what the robot needs to measure", description: "Explore sensing for motion, contact and the surrounding environment. Connect sensor selection to lighting, object materials, required accuracy and the consequences of a missed measurement." },
      { path: "/robot-components", label: "Explore robot components", description: "Look at actuators, transmissions and other hardware within a complete robot. Use manufacturer documentation to check the exact model, electrical requirements and operating limits." },
      { path: "/robotics-software", label: "Plan the software stack", description: "Browse tools for robot development, perception, simulation and control. Start from your hardware interfaces and deployment environment before choosing the software around them." },
      { path: "/physical-ai", label: "Understand Physical AI", description: "Follow how observations become actions in a physical system. Read about learning, world models and evaluation, with attention to the difference between simulation results and hardware trials." },
      { path: "/robotics-companies", label: "Research robotics suppliers", description: "Find companies by location and product area. Follow the official product sources to check availability, service coverage and whether a supplier supports your intended application." },
      { path: "/ai/best-humanoid-robot-certifications-2026", label: "Plan a robotics learning route", description: "Compare training and certification paths with your intended role. Programming, simulation, maintenance and machinery safety call for different practical experience." },
      { path: "/robotics-news", label: "Follow current releases and research", description: "Read recent product announcements and research analyses. Each article should make it possible to trace the reported result back to the company material, paper or project page." },
    ],
  },
  {
    path: "/de/ai",
    basePath: "/ai",
    locale: "de",
    lang: "de",
    localeName: "Deutsch",
    title: "KI-Ratgeber, Tools und Modellvergleiche TechniaHQRobot",
    heading: "KI-Ratgeber, Tools und Modellvergleiche",
    eyebrow: "Deutsche KI-Bibliothek",
    description: "Ausgewählte deutschsprachige KI-Ratgeber zu Modellen, Programmierwerkzeugen und Weiterbildung mit Links zu den beschriebenen Funktionen und Grenzen.",
    intro: "Wählen Sie einen Ratgeber zu KI-Modellen, Programmierwerkzeugen oder Weiterbildung und vergleichen Sie die beschriebenen Möglichkeiten und Grenzen.",
    directoryHeading: "Ausgewählte deutsche KI-Ratgeber",
  },
  {
    path: "/de/robotics",
    basePath: "/robotics",
    locale: "de",
    lang: "de",
    localeName: "Deutsch",
    title: "Robotik-Analysen, Hardware und Physical AI TechniaHQRobot",
    heading: "Robotik-Analysen und Physical AI",
    eyebrow: "Deutsche Robotik-Bibliothek",
    description: "Öffnen Sie deutsche Analysen zu Robotik, Hardware, Physical AI, humanoiden Systemen, Fertigungsplänen und realen technischen Grenzen.",
    intro: "Der Hub verbindet die veröffentlichten deutschen Robotik-Analysen direkt mit der Sprachstartseite und den benachbarten Verzeichnissen.",
    directoryHeading: "Deutsche Robotik-Analysen",
  },
  {
    path: "/fr/ai",
    basePath: "/ai",
    locale: "fr",
    lang: "fr",
    localeName: "Français",
    title: "Guides IA, outils et comparatifs de modèles TechniaHQRobot",
    heading: "Guides IA, outils et comparatifs de modèles",
    eyebrow: "Bibliothèque IA en français",
    description: "Parcourez les guides français sur ChatGPT, Claude, Gemini, Grok, DeepSeek, les outils de code, les certifications, les cours et les comparatifs.",
    intro: "Choisissez un guide sur les modèles d’IA, les outils de programmation ou les formations pour comparer leurs usages et leurs limites.",
    directoryHeading: "Tous les guides IA en français",
  },
  {
    path: "/fr/robotics",
    basePath: "/robotics",
    locale: "fr",
    lang: "fr",
    localeName: "Français",
    title: "Analyses robotiques, matériel et IA physique TechniaHQRobot",
    heading: "Analyses robotiques et IA physique",
    eyebrow: "Bibliothèque robotique française",
    description: "Consultez les analyses françaises sur la robotique, le matériel, l’IA physique, les robots humanoïdes, les feuilles de route et leurs limites.",
    intro: "Ce hub relie les analyses robotiques françaises à l’accueil de l’édition, aux entreprises, aux événements et aux actualités.",
    directoryHeading: "Analyses robotiques en français",
  },
  {
    path: "/ja/ai",
    basePath: "/ai",
    locale: "ja",
    lang: "ja",
    localeName: "日本語",
    title: "AIガイド・ツール・モデル比較記事一覧 TechniaHQRobot",
    heading: "AIガイド・ツール・モデル比較",
    eyebrow: "日本語AIライブラリ",
    description: "ChatGPT、Claude、Gemini、Grok、DeepSeek、画像生成、動画生成、コーディング、認定資格などの日本語AIガイドを一覧で確認できます。",
    intro: "AIモデル、開発ツール、学習や資格に関するガイドを選び、用途や制約を確認できます。",
    directoryHeading: "日本語のAIガイド一覧",
  },
  {
    path: "/ja/robotics",
    basePath: "/robotics",
    locale: "ja",
    lang: "ja",
    localeName: "日本語",
    title: "ロボット技術・ハードウェア・フィジカルAIガイド TechniaHQRobot",
    heading: "ロボット技術とフィジカルAI",
    eyebrow: "日本語ロボティクスライブラリ",
    description: "ロボット技術、ハードウェア、フィジカルAI、ヒューマノイド、開発ロードマップ、実機データの日本語分析をまとめています。",
    intro: "日本語版トップ、企業、イベント、ニュースから技術分析へ移動できるよう、公開済みページをこのハブにまとめました。",
    directoryHeading: "日本語のロボティクス分析",
  },
  {
    path: "/zh-cn/ai",
    basePath: "/ai",
    locale: "zh-cn",
    lang: "zh-CN",
    localeName: "简体中文",
    title: "AI指南、工具与模型对比文章 TechniaHQRobot",
    heading: "AI指南、工具与模型对比",
    eyebrow: "简体中文AI内容库",
    description: "浏览简体中文AI指南，涵盖ChatGPT、Claude、Gemini、Grok、DeepSeek、编程工具、图像视频生成、课程与认证。",
    intro: "选择关于AI模型、编程工具、课程或认证的指南，了解其用途、使用方法和局限。",
    directoryHeading: "全部简体中文AI指南",
  },
  {
    path: "/zh-cn/robotics",
    basePath: "/robotics",
    locale: "zh-cn",
    lang: "zh-CN",
    localeName: "简体中文",
    title: "机器人技术、硬件与物理AI指南 TechniaHQRobot",
    heading: "机器人技术、硬件与物理AI",
    eyebrow: "简体中文机器人内容库",
    description: "汇总机器人技术、硬件、物理AI、人形机器人、开发路线图和真实训练数据分析，并连接企业、活动与机器人新闻栏目。",
    intro: "阅读机器人硬件、物理AI和开发计划的分析，并查看相关企业、活动和新闻。",
    directoryHeading: "简体中文机器人分析",
  },
];

export const searchConsoleEditionHubs = {
  "/de": ["/de/ai", "/de/humanoid-robots", "/de/robotics", "/de/robotics-news", "/de/robotics-companies", "/de/robotics-events"],
  "/fr": ["/fr/ai", "/fr/humanoid-robots", "/fr/robotics", "/fr/robotics-news", "/fr/robotics-companies", "/fr/robotics-events"],
  "/ja": ["/ja/ai", "/ja/humanoid-robots", "/ja/robotics", "/ja/robotics-news", "/ja/robotics-companies", "/ja/robotics-events"],
  "/zh-cn": ["/zh-cn/ai", "/zh-cn/humanoid-robots", "/zh-cn/robotics", "/zh-cn/robotics-news", "/zh-cn/robotics-companies", "/zh-cn/robotics-events"],
};

export const searchConsoleSectionCopy = {
  en: {
    eyebrow: "Article library",
    title: "Pages linked from this section",
    description: "Explore the articles below for explanations, comparisons and supporting sources.",
    open: "Open page",
    editionEyebrow: "Edition navigation",
    editionTitle: "Explore this language edition",
    editionDescription: "Open the main topic hubs before moving to individual articles.",
  },
  de: {
    eyebrow: "Artikelübersicht",
    title: "Seiten in dieser Rubrik",
    description: "Entdecken Sie Erklärungen, Vergleiche und weiterführende Quellen in den Artikeln dieser Rubrik.",
    open: "Seite öffnen",
    editionEyebrow: "Navigation der Ausgabe",
    editionTitle: "Diese Sprachausgabe erkunden",
    editionDescription: "Öffnen Sie zuerst die Themenbereiche und danach die einzelnen Artikel.",
  },
  fr: {
    eyebrow: "Bibliothèque d’articles",
    title: "Pages reliées à cette rubrique",
    description: "Retrouvez les explications, les comparatifs et leurs sources dans les articles de cette rubrique.",
    open: "Ouvrir la page",
    editionEyebrow: "Navigation de l’édition",
    editionTitle: "Explorer cette édition linguistique",
    editionDescription: "Accédez aux rubriques principales avant d’ouvrir les articles.",
  },
  ja: {
    eyebrow: "記事一覧",
    title: "このカテゴリに含まれるページ",
    description: "各記事で技術の解説、比較、参照資料を確認できます。",
    open: "ページを開く",
    editionEyebrow: "言語版ナビゲーション",
    editionTitle: "この言語版を探す",
    editionDescription: "各記事を開く前に主要カテゴリを確認できます。",
  },
  "zh-cn": {
    eyebrow: "文章目录",
    title: "本栏目链接的页面",
    description: "浏览本栏目的技术解读、对比分析和参考资料。",
    open: "打开页面",
    editionEyebrow: "语言版本导航",
    editionTitle: "浏览本语言版本",
    editionDescription: "先进入主要栏目，再查看具体文章。",
  },
};

export function normalizeSearchConsolePath(path = "/") {
  if (!path || path === "/") return "/";
  const pathname = String(path).split("?")[0].replace(/\/+$/, "") || "/";
  return pathname.startsWith("/") ? pathname : `/${pathname}`;
}

export function getSearchConsoleHubPage(path = "/") {
  const normalized = normalizeSearchConsolePath(path);
  return searchConsoleHubPages.find((page) => page.path === normalized) || null;
}

export function getSearchConsoleHubAlternates(path = "/") {
  const page = getSearchConsoleHubPage(path);
  if (!page) return [];

  const alternates = searchConsoleHubPages
    .filter((candidate) => candidate.basePath === page.basePath)
    .map((candidate) => ({
      locale: candidate.locale,
      hreflang: candidate.lang,
      href: candidate.path,
    }));

  if (page.basePath === "/robotics") {
    alternates.unshift({ locale: "en", hreflang: "en", href: "/robotics" });
  }

  return alternates;
}
